// extracted by mini-css-extract-plugin
export default {"load":"loading_load__cX0Aa","rotate":"loading_rotate__pWGBd","load_1":"loading_load_1__18VFF","load_5":"loading_load_5__ALbht","load_10":"loading_load_10__uMPNG"};